<template>
  <v-layout row wrap v-if="item">
    <v-flex xs12 md12>
      <v-text-field
        label="Name"
        :rules="nameRules"
        v-model="item.name"
        :counter="255"
        required
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md12>
      <v-list>
        <v-list-tile>
          <v-list-tile-content>Quantity</v-list-tile-content>
          <v-list-tile-action class="text-xs-right">
            <vue-numeric-input
              v-model="item.quantity"
              :min="0"
              :step="1"
              :precision="0"
              controls-type="updown"
              @input="updateValue"
              align="right"></vue-numeric-input>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Price / Unit</v-list-tile-content>
          <v-list-tile-action class="text-xs-right">
            <vue-numeric-input
              v-model="item.unitPrice"
              :min="0"
              :step="1"
              :precision="2"
              controls-type="updown"
              @input="updateValue"
              align="right"></vue-numeric-input>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Amount</v-list-tile-content>
          <v-list-tile-action class="text-xs-right">
            {{ totalPrice | currency('', 2) }}
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Vat {{ vatPercentage }}%</v-list-tile-content>
          <v-list-tile-action class="text-xs-right">
            {{ taxPrice | currency('', 2) }}
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>Total</v-list-tile-content>
          <v-list-tile-action class="text-xs-right">
            {{ (totalPrice + taxPrice) | currency('', 2) }}
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ItemShow',
  props: {
    value: Object,
    vatIncluded: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      item: this.value,
      nameRules: [
        v => !!v || 'Name is required'
      ]
    }
  },
  computed: {
    ...mapGetters({
      vat: 'systemSetting/vat'
    }),
    vatPercentage () {
      return (this.vatIncluded) ? this.vat : 0.0
    },
    totalPrice () {
      return this.item.quantity * this.item.unitPrice
    },
    taxPrice () {
      return this.totalPrice * this.vatPercentage / 100
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.item)
    }
  },
  watch: {
    value () {
      this.item = this.value
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/item/Item.vue